import React from 'react';

import InfoCard, { InfoCardProps } from '../InfoCard';

import styles from './index.module.scss';

export interface InfoCardListProps {
  cards: InfoCardProps[];
}

const InfoCardList: React.FC<InfoCardListProps> = ({ cards }) => {
  return (
    <div className={styles.wrapper}>
      {cards.map((card, index) => (
        <InfoCard key={index} {...card} />
      ))}
    </div>
  );
};

export default InfoCardList;
